export const config = {
  propsName: 'renderProps',
  name: 'SpCheckbox',
  type: 'formTmpsConfig',
  icon: 'el-icon-folder-checked',
  cnName: '多选框',
  base: {
    title: '多选框',
    //subtitle: 'SpSelect_subtitle',
    padded: true,
    flex: '1',
    margin: [0, 0, 0, 0],
    
  },
  props: [
    {
      type: 'el-switch',
      key: 'required',
      bind: {
        label: '是否必填'
      },
      value: false
    },
    {
      type: 'el-input',
      key: 'title',
      bind: {
        label: '多选框名称',
        placeholder: '请输入名称'
      },
      value: '多选框名称'
    },
    {
      type: () => import('@/weappTmps/comps/addCheckboxOptions/index.vue'),
      cmpPath: '/comps/addCheckboxOptions/index.vue',
      key: 'selectVal',
      bind: {
        label: ''
      },
      value:{
        addOptions: [],
        defaultValue: []
      }
    }
  ]
}
